export type BusinessInfoData = {
  countryOfRegistrationCode: string | null;
  registrationNumber?: string | null;
  vatNumber?: string | null;
  tradeName: string | null;
  fileNumber: string | null;
};
